<template>
  <main>
    <div data-scroll-el="pdpContainer" />
    <div :class="{ 'fit-finder-container': $feature.showFitFinderOnPDP }">
      <slot name="notifications" />
      <transition name="fade">
        <div v-if="productPending && !product">
          <pdp-skeleton />
        </div>
        <div v-else-if="product">
          <div class="lg:mb-10 lg:flex lg:items-start">
            <section class="relative lg:grow" data-scroll-el="gallery">
              <pdp-section-breadcrumbs
                class="m-2 px-2 py-1 bg-grey-80 bg-op-80 left-0 top-0 absolute z-1 lg:!hidden"
              />
              <slot name="gallery" />
            </section>
            <section
              v-style="{ w: { lg: '30rem' }, top: { lg: '6rem' } }"
              class="px-4 space-y-2 lg:px-6 lg:pt-12 lg:shrink-0 lg:sticky"
            >
              <div class="f-col gap-4 <lg:hidden">
                <slot name="breadcrumbs" />
                <slot name="heading" />
                <slot name="paypal-payments" />
              </div>
              <pdp-section-gift-card v-if="isDigitalProduct">
                <div class="mt-4 pt-4 b-t b-grey-70 lg:hidden">
                  <slot name="heading" />
                  <slot name="paypal-payments" />
                </div>
              </pdp-section-gift-card>
              <pdp-section-variant-selection v-else>
                <div class="mt-4 pt-4 b-t b-grey-70 lg:hidden">
                  <slot name="heading" />
                  <slot name="paypal-payments" />
                </div>
                <template #ctas>
                  <slot name="ctas" />
                </template>
              </pdp-section-variant-selection>
              <div class="w-full space-y-2">
                <pdp-section-apple-pay />
                <div class="mb-4 flex between">
                  <!-- todo: create slots for 'size-chart' and 'find-in-store' -->
                  <pdp-section-size-chart v-if="!isDigitalProduct && showSizeAndFit" />
                  <pdp-section-find-in-store v-if="!isDigitalProduct" />
                </div>
              </div>
              <slot name="shipping-methods" />
            </section>
          </div>
          <div
            v-if="!isDigitalProduct"
            v-style:mx="{ lg: '4rem' }"
            class="px-4 pb-10 lg:px-6 lg:pb-16 <lg:pt-10"
          >
            <slot name="accordions" />
            <slot name="espot-below-accordions" />
          </div>
          <slot name="shop-the-look" />
          <slot name="recommendations" />
          <slot name="espot-lazy-below-gallery" />
          <slot name="reviews" />
          <slot name="espot-lazy-above-footer" />
        </div>
      </transition>
    </div>
    <client-only>
      <teleport to="body">
        <slot name="body" />
      </teleport>
    </client-only>
    <slot />
  </main>
</template>

<script setup lang="ts">
defineSlots<{
  'accordions': void
  'body': void
  'breadcrumbs': void
  'ctas': void
  'espot-below-accordions': void
  'espot-lazy-above-footer': void
  'espot-lazy-below-gallery': void
  'gallery': void
  'heading': void
  'notifications': void
  'paypal-payments': void
  'recommendations': void
  'reviews': void
  'shipping-methods': void
  'shop-the-look': void
  'skeletons': void
  'variant-selection': void
}>()

const { isDigitalProduct, product, productPending, showSizeAndFit } = usePdp()
</script>
